/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} Chat_Ask_User_Step_ShortInputs */



/**
* | output |
* | --- |
* | "{current}/{total}" |
*
* @param {Chat_Ask_User_Step_ShortInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_ask_user_step_short = /** @type {((inputs: Chat_Ask_User_Step_ShortInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Ask_User_Step_ShortInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.current}/${i?.total}`)
	return /** @type {LocalizedString} */ (`${i?.current}/${i?.total}`)
});